import type { Color } from "@deck.gl/core";

export const FILL_COLOUR_15: Color = [8, 81, 156, 255 * 0.4];
export const FILL_COLOUR_60: Color = [8, 81, 156, 255 * 0.2];
export const LINE_COLOUR: Color = [8, 81, 156, 255 * 0.7];
